/*
  Consentmo cookie banner: compact bottom bar on mobile, Articulat, no backdrop, no focus ring on open.

  Consentmo renders into the open shadow root of <csm-cookie-consent>, so theme CSS can't reach it.
  This adds one <style> as the last child of that root (so it wins the cascade over Consentmo's own
  sheets, including its `font-family: Inter !important`). Selectors use only Consentmo's stable
  names (csm-native-*, csm-*-button, data-csm-button-type, #csm-wrapper, #cookieconsent-desc), never
  its generated class hashes. If Consentmo changes its markup the rules stop matching and the banner
  falls back to its own design; nothing here can hide it or block a choice.

  Layout/overlay should also be set in the Consentmo admin; this is the polish on top.
*/
(function () {
  var CSS = [
    /* Brand font everywhere in the banner (beats Consentmo's id + class + * !important rule by order) */
    '#csm-wrapper .csm-native-blur-wrapper *, #csm-wrapper .csm-native-main-wrapper * { font-family: articulat-cf, sans-serif !important; }',
    /* No backdrop: the full-screen wrapper stays transparent and lets taps through to the page */
    '#csm-wrapper .csm-native-blur-wrapper { background: transparent !important; backdrop-filter: none !important; -webkit-backdrop-filter: none !important; pointer-events: none !important; }',
    '#csm-wrapper .csm-native-main-wrapper { pointer-events: auto !important; }',
    /* Consentmo focuses the description on open (tabindex=-1, never reachable by Tab): no ring for that */
    '#cookieconsent-desc:focus { outline: none !important; box-shadow: none !important; }',
    '@media (max-width: 749px) {',
    '  #csm-wrapper .csm-native-main-wrapper { left: 0 !important; right: 0 !important; bottom: 0 !important; transform: none !important; width: 100% !important; max-width: none !important; border-radius: 14px 14px 0 0 !important; padding: 12px 16px calc(10px + env(safe-area-inset-bottom, 0px)) !important; box-shadow: 0 -4px 20px rgba(0, 0, 0, .12) !important; }',
    '  #csm-wrapper .csm-native-cookie-title { display: none !important; }',
    '  #csm-wrapper .csm-native-btn-close { top: 6px !important; right: 6px !important; transform: scale(.8); }',
    '  #csm-wrapper .csm-native-cookie-paragraph { margin: 0 28px 10px 0 !important; padding: 0 !important; font-size: 13px !important; line-height: 1.4 !important; max-height: none !important; border: 0 !important; }',
    '  #csm-wrapper .csm-native-cookie-paragraph * { font-size: 13px !important; line-height: 1.4 !important; }',
    '  #csm-wrapper .csm-native-button-container { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; gap: 8px !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }',
    '  #csm-wrapper .csm-native-button-container .csm-cookie-button { flex: 1 1 0 !important; min-width: 0 !important; width: auto !important; height: 40px !important; min-height: 40px !important; margin: 0 !important; padding: 0 12px !important; font-size: 14px !important; box-shadow: none !important; }',
    '  #csm-wrapper .csm-native-button-container .csm-preferences-button { flex: 1 0 100% !important; height: 28px !important; min-height: 28px !important; background: none !important; border: 0 !important; text-decoration: underline !important; font-size: 13px !important; }',
    '  #csm-wrapper .csm-native-button-container .csm-preferences-button::before, #csm-wrapper .csm-native-button-container .csm-preferences-button::after { display: none !important; }',
    '}'
  ].join('\n');

  function apply(host) {
    var root = host && host.shadowRoot;
    if (!root) return false;
    var style = root.getElementById('pmx-consent-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'pmx-consent-style';
      style.textContent = CSS;
    }
    // Keep it last: Consentmo appends its own <link> sheets as it builds the banner
    if (root.lastChild !== style) root.appendChild(style);
    return true;
  }

  // Consentmo inserts <csm-cookie-consent> and attaches its shadow root later (no DOM mutation
  // fires for that), so poll briefly, then keep the style last with an observer on the root.
  var watched = null;
  var tries = 0;
  var timer = setInterval(function () {
    var host = document.querySelector('csm-cookie-consent');
    if (host && host !== watched && apply(host)) {
      watched = host;
      new MutationObserver(function () { apply(host); }).observe(host.shadowRoot, { childList: true });
    }
    // Stop after 30s (banner not shown in this region, or app off)
    if (++tries > 120) clearInterval(timer);
  }, 250);
})();
